import {
    graphql
} from 'react-relay'


const query = graphql`
    query getAllProjectPhaseQuery($pagination: PaginationInput, $sorts: [OrderInput!], $where: JSON) {
        getAllProjectPhase (pagination: $pagination, sorts: $sorts, where: $where){
            count,
            items{id, name, color, createdAt, updatedAt}
      }
    }
  `

  export default query;